export default "__VITE_ASSET__8F1Ysven__"